module.exports = __webpack_public_path__ + "static/media/zhan23multi.651c8c97.avif";